import React from 'react'

import { useIsNewLayout } from 'containers/App/NewLayout/useIsNewLayout'

import { HomePage as NewHomePage } from './New'
import Loadable from './Old/LoadableBetor'

export default function BetorHomePage() {
  const isNewLayout = useIsNewLayout()

  if (isNewLayout) {
    return <NewHomePage />
  }

  return <Loadable />
}
